<template>
    <vx-card title="Редактирование типа DSP" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.name" :danger="!!errors.name" :danger-text="errors.name" autocomplete="off"
                        label="Название типа DSP" class="mt-1 w-full required" />
                </div>
            </div>
        </div>

        <div class="vx-row mt-4 mb-4">
            <div class="vx-col w-1/2">
                <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="form.isStoreResponsesAll">
                    Писать все ответы
                </vs-checkbox>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> КХ поля для записи </label>
                    <v-select label="name" multiple :options="dicts.optionalStatFields" placeholder="Выберите поля"
                        class="w-full" v-model="form.optionalStatFieldIds" :reduce="(a) => a.id">
                    </v-select>
                </div>
                <router-link :to="{ name: 'optional-stat-fields' }">
                    Список доступных полей
                </router-link>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveDSPType()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'dsptype-edit',
    props: ['id'],
    data() {
        return {
            dsptype: undefined,
            dicts: {
                optionalStatFields: [],
            },
            form: {
                name: undefined,
                optionalStatFieldIds: undefined,
                isStoreResponsesAll: false
            },
            errors: {
                name: '',
            }
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadDicts() {
            this.axios.get('dsptypes/dicts').then((dicts) => {
                this.dicts.optionalStatFields = dicts.data.optionalStatFields;
            });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.get('dsptypes/' + this.id)
                .then((dsptype) => {
                    this.dsptype = dsptype.data;
                    this.form.name = dsptype.data.name;
                    this.form.optionalStatFieldIds = dsptype.data.optionalStatFieldIds;
                    this.form.isStoreResponsesAll = dsptype.data.isStoreResponsesAll;
                })
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки типа DSP.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        saveDSPType() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.form, { id: this.id });
            this.$axios({
                method: 'PUT',
                url: 'dsptypes/' + this.id,
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Тип DSP успешно обновлен",
                        color: "success",
                    });
                    this.$router.push('/dsptypes');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при редактировании типа DSP!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/dsptypes');
        }
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    }
}
</script>

<style>
.select-error>div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>